var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"AccountScheduledReportsRuns"}},[_c('Page',{attrs:{"title":_vm.$t('scheduledReports.generatedReports'),"breadcrumbs":[
        {
          label: _vm.$t('Back to list'),
          onAction: function () { return _vm.backToList(); }
        }
      ],"fullWidth":""}},[(_vm.loading)?_c('LoadingLayout'):_vm._e(),(!_vm.loading)?_c('Layout',[_c('LayoutSection',[_c('Card',[_c('Filters',{attrs:{"filters":[
              {
                key: 'reportId',
                label: this.$t('scheduledReports.report'),
                type: 'select',
                placeholder: this.$t('scheduledReports.chooseReport'),
                options: _vm.reports
              }
            ],"query":_vm.query,"applied-filters":_vm.appliedFilters},on:{"update:query":[function($event){_vm.query=$event},_vm.setQuery],"update:applied-filters":_vm.setAppliedFilters}}),_c('DataTable',{attrs:{"columns":[
              {
                key: 'url',
                label: _vm.$t('scheduledReports.fileName')
              },
              {
                key: 'status',
                label: _vm.$t('Status')
              },
              {
                key: 'createdOn',
                label: _vm.$t('scheduledReports.runDate'),
                format: 'dateLong'
              }
            ],"rows":_vm.formattedRuns,"row-actions":function (row) { return _vm.getRowActions(row); },"loading":_vm.loading,"pagination":{
              offset: _vm.offset,
              limit: _vm.limit,
              total: _vm.formattedRuns.length,
              updateOffset: _vm.updateOffset,
              updateLimit: _vm.updateLimit
            }}})],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }